module.exports = __webpack_public_path__ + "media/arrows.3f2de8dd.webm";